module.exports = __webpack_public_path__ + "img/wecom-temp-441ae10872831861cf94fd4d30e4514a.441ae108.png";